import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const products = [
  {
    id: "panel-cit",
    code: "01",
    title: "Panel & Örgü Çit Sistemi",
    desc: "Galvanizli ve PVC kaplı 3D panel çit çözümleri. Endüstriyel tesis, OSB, site ve özel alanlar için modern güvenlik standardı.",
    image: "https://customer-assets.emergentagent.com/job_telecom-pro-6/artifacts/7ya78s9f_IMG-20260610-WA0008.jpg",
    specs: ["Göz: 50x50 / 60x60 mm", "Yükseklik: 100 - 250 cm", "Kaplama: Galv. + RAL PVC"],
  },
  {
    id: "modern-kapi",
    code: "02",
    title: "Modern Bahçe & Villa Kapısı",
    desc: "Lazer kesim ve lameli panel teknolojisi ile özel tasarım modern bahçe kapıları. Villa, site ve kurumsal projeler için.",
    image: "https://customer-assets.emergentagent.com/job_telecom-pro-6/artifacts/13tvo0d6_IMG-20260610-WA0006.jpg",
    specs: ["Profil: Lameli / Düz", "Renk: RAL özel tonlar", "Motor & otomasyon opsiyonel"],
  },
  {
    id: "dekoratif-kapi",
    code: "03",
    title: "Dekoratif & Ferforje Kapı",
    desc: "Klasik ve dekoratif desenli ferforje kapılar. Lüks villa, malikane ve özel mekanlar için el işçiliği üretim.",
    image: "https://customer-assets.emergentagent.com/job_telecom-pro-6/artifacts/u9ktfxaw_IMG-20260610-WA0005.jpg",
    specs: ["3D piramit desen", "Altın varak detaylar", "Özel tasarım & ölçü"],
  },
  {
    id: "endustriyel-cit",
    code: "04",
    title: "Endüstriyel Çit & Sürgülü Kapı",
    desc: "Fabrika, depo ve OSB alanları için ağır hizmet tipi sürgülü kapı ve panel çit sistemleri. Motorlu otomasyon destekli.",
    image: "https://customer-assets.emergentagent.com/job_telecom-pro-6/artifacts/q3it63e5_IMG-20260610-WA0009.jpg",
    specs: ["Sürgülü / kanatlı tip", "Motor: 600 - 1200 kg", "Galvaniz + RAL boya"],
  },
];

export default function Products() {
  return (
    <section
      id="urunler"
      data-testid="products-section"
      className="relative bg-[#fafafa] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FF5A00]/10 text-[#FF5A00] font-mono-disp text-[11px] font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FF5A00]" />
              Ürün Yelpazesi
            </div>
            <h2 className="font-display mt-5 text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tighter leading-[1.02] max-w-3xl text-gray-900">
              Endüstriyel ihtiyaçlar için{" "}
              <span className="font-serif-disp font-normal text-[#FF5A00]">
                eksiksiz
              </span>{" "}
              ürün ailesi
            </h2>
          </div>
          <p className="font-body text-base text-gray-600 max-w-md">
            Galvanizli telden jiletli güvenlik sistemlerine kadar 4 ana ürün
            grubunda binlerce farklı ebat ve gramajda üretim yapıyoruz.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {products.map((p, idx) => (
            <motion.article
              key={p.id}
              data-testid={`product-card-${p.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, delay: idx * 0.08 }}
              className="group card-mod overflow-hidden"
            >
              <div className="grid grid-cols-1 sm:grid-cols-5 min-h-[320px]">
                <div className="sm:col-span-2 relative overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  <div className="absolute top-3.5 left-3.5 bg-white/90 backdrop-blur-md px-2.5 py-1 rounded-full font-mono-disp text-[10px] font-semibold text-gray-900">
                    {p.code} / 04
                  </div>
                </div>
                <div className="sm:col-span-3 p-6 sm:p-7 flex flex-col justify-between">
                  <div>
                    <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-gray-900">
                      {p.title}
                    </h3>
                    <p className="font-body mt-2.5 text-sm text-gray-600 leading-relaxed">
                      {p.desc}
                    </p>
                    <ul className="mt-4 pt-4 border-t border-gray-100 space-y-1.5">
                      {p.specs.map((s) => (
                        <li
                          key={s}
                          className="font-mono-disp text-[11px] text-gray-500 flex items-start gap-2"
                        >
                          <span className="text-[#FF5A00] mt-0.5">→</span>
                          {s}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="mt-5 flex items-center justify-between">
                    <span className="font-mono-disp text-[10px] text-gray-400 uppercase tracking-wider">
                      Detay
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-[#FF5A00] font-medium text-sm group-hover:gap-2.5 transition-all">
                      Teklif Al
                      <ArrowUpRight className="w-4 h-4" />
                    </span>
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
